__turbopack_context__.v({
  "bottom-section": "footer-module-scss-module__3NmrYW__bottom-section",
  "copyright": "footer-module-scss-module__3NmrYW__copyright",
  "facebook": "footer-module-scss-module__3NmrYW__facebook",
  "footer": "footer-module-scss-module__3NmrYW__footer",
  "footer-content": "footer-module-scss-module__3NmrYW__footer-content",
  "instagram": "footer-module-scss-module__3NmrYW__instagram",
  "link": "footer-module-scss-module__3NmrYW__link",
  "link-list": "footer-module-scss-module__3NmrYW__link-list",
  "linkedin": "footer-module-scss-module__3NmrYW__linkedin",
  "logo": "footer-module-scss-module__3NmrYW__logo",
  "logo-and-navigation": "footer-module-scss-module__3NmrYW__logo-and-navigation",
  "logo-section": "footer-module-scss-module__3NmrYW__logo-section",
  "nav-section": "footer-module-scss-module__3NmrYW__nav-section",
  "navigation": "footer-module-scss-module__3NmrYW__navigation",
  "section-title": "footer-module-scss-module__3NmrYW__section-title",
  "social-button": "footer-module-scss-module__3NmrYW__social-button",
  "social-icons": "footer-module-scss-module__3NmrYW__social-icons",
});
